import { types } from 'mobx-state-tree';

export default types.model('UserSummary', {
  created_at: types.string,
  name: types.union(types.null, types.string),
  email: types.string,
  registration_method: types.string,
});
